import { URL_GET_USER_API } from 'constants/urls';

/**
 * @function getUserApi
 * @param {string} id User id
 * @returns {object}
 */
async function getUserApi(id) {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};
	const url = `${URL_GET_USER_API}${id}}`;
	const res = await fetch(url, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		const data = await res.json();
		return data;
	}
}

export default getUserApi;
